export default "__VITE_ASSET__BbkXp_wt__"